<template>
  <v-app>
    <LoadingComponent :isLoading="$store.getters.loadingModal" />
    <!--		<LoginModal/>-->

    <v-app-bar app elevation="11" class="app-gradient" height="75">
      <div class="header-layout">
        <div class="header-slot header-slot-left">
          <v-img
            :src="require('./assets/Eudoxus_Logo_RGB_Gr.png')"
            class="header-logo"
            contain
            alt="Eudoxus"
          ></v-img>
        </div>

        <div class="header-slot header-slot-center">
          <Footer />
        </div>

        <div class="header-slot header-slot-right"></div>
      </div>
    </v-app-bar>

    <v-main class="mt-1 app-gradient" style="padding-bottom: 0">
      <router-view></router-view>
    </v-main>
    <ErrorPopup />
    <!-- <InstructionsDialog/> -->
  </v-app>
</template>

<script>
import utils from "./utilities";
import requests from "./requests";
import store from "./store";

import LoadingComponent from "./components/LoadingComponent";
import Footer from "./components/Footer";
import ErrorPopup from "./components/ErrorPopup";

export default {
  name: "App",
  components: { ErrorPopup, LoadingComponent, Footer },
  data: () => ({
    drawer: true,
    navigationPath: "/",
  }),

  methods: {},

  created() {},

  watch: {
    $route(to, from) {
      if (to.path !== this.navigationPath) {
        this.navigationPath = to.path;
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

.v-btn {
  text-transform: none !important;
  font-weight: bold !important;
}
.v-tab {
  text-transform: none !important;
  font-weight: bold !important;
}

nav a.router-link-exact-active {
  color: #42b983;
}

/* Global text color override */
.v-application {
  color: #454545 !important;
}

/* Specific Vuetify component text colors */
.v-card__title,
.v-card__subtitle,
.v-expansion-panel-header,
.v-data-table,
.v-list-item__title,
.v-list-item__subtitle,
.v-data-table th,
.v-data-table td {
  color: #454545 !important;
}

/* Gradient backgrounds - reusable class */
.app-gradient {
  background: #8c8c8c;
  background: linear-gradient(
    90deg,
    rgba(60, 60, 60, 1) 0%,
    rgba(140, 140, 140, 1) 50%,
    rgba(220, 220, 220, 1) 100%
  );
}

/* Header layout */
.header-layout {
  display: flex;
  align-items: center;
  width: 100%;
}

.header-slot {
  display: flex;
  align-items: center;
}

.header-slot-left,
.header-slot-right {
  flex: 0 0 220px;
}

.header-slot-center {
  flex: 1;
  justify-content: center;
}

.header-logo {
  max-width: 200px;
  max-height: 64px;
}
</style>

<style scoped></style>
